<template>
  <div class="navhead">
    <div class="headerTitle">
      <img
        src="../assets/img/main/logo.png"
        alt=""
        style="margin-right:100px;width:156px;height44px;vertical-align:middle;cursor:pointer;"
        @click="handleMain"
      />
      <span
        class="el-dropdown-link wiew"
        @click="handleMain"
        :class="{ right: $route.name == navname[0].name }"
      >
        <!-- 首页 -->
        {{$t('navbar.home')}}
      </span>
      <el-dropdown placement="bottom">
        <span
          class="el-dropdown-link wiew"
          :class="
            $route.name == navname[1].name
              ? 'right'
              : $route.name == navname[6].name
              ? 'right'
              : $route.name == navname[7].name
              ? 'right'
              : $route.name == navname[8].name
              ? 'right'
              : ''
          "
        >
          <!-- 产品体系 -->
          {{$t('navbar.ProductSystem')}}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, i) in $t('navbar.dropList')"
            :key="i"
            @click.native="handleProject(item.type)"
          >
            <div style="width:100%;display:flex;justify-content: center;">
              <div class="widimg">
                <img
                  :src="item.img"
                  alt=""
                  class="conimgheader"
                />
              </div>
            </div>

            <p
              @mouseover="item.img = item.imgs"
              @mouseout="item.img = item.img1"
            >
              <span style="font-size:14px;"> {{ item.name }}</span>
              <span style="font-size:12px;display:block;line-height:10px;padding-bottom:10px;">{{ item.names }}</span>
            </p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown placement="bottom">
        <span
          class="el-dropdown-link wiew wr"
          :class="
            $route.name == navname[2].name
              ? 'right'
              : $route.name == navname[9].name
              ? 'right'
              : ''
          "
        >
          {{$t('navbar.solution')}}
          <!-- 解决方案 -->
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, i) in $t('navbar.solutList')"
            :key="i"
            @click.native="handleSolute(item.type)"
          >
            <div style="width:100%;display:flex;justify-content: center;">
              <div class="widimg">
                <img
                  :src="item.img"
                  class="conimgheader"
                  alt=""
                />
              </div>
            </div>
            <p
              @mouseover="item.img = item.imgs"
              @mouseout="item.img = item.img1"
            >
              {{ item.name }}
            </p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span
        class="el-dropdown-link wiew"
        @click="handlePrice"
        :class="{ right: $route.name == navname[3].name }"
      >
        {{$t('navbar.price')}}
        <!-- 价格 -->
      </span>
      <el-dropdown placement="bottom">
        <span
          class="el-dropdown-link wiew"
          :class="
            $route.name == navname[5].name
              ? 'right'
              : $route.name == navname[4].name
              ? 'right'
              : ''
          "
        >
          {{$t('navbar.AboutUs')}}
          <!-- 关于我们 -->
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, is) in $t('navbar.aboutus')"
            :key="is"
            @click.native="handleus(item.type)"
          >
            <div style="width:100%;display:flex;justify-content: center;">
              <div class="widimg">
                <img
                  :src="item.img"
                  class="conimgheader"
                  alt=""
                />
              </div>
            </div>

            <p
              @mouseover="item.img = item.imgs"
              @mouseout="item.img = item.img1"
            >{{ item.name }}
            </p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    needFixed: Boolean
  },
  data() {
    return {
      // dropList: [
      //   {
      //     name: "DCI互联",
      //     names: "SD-DCI",
      //     img1: require("../assets/img/header/DCI.png"),
      //     img: require("../assets/img/header/DCI.png"),
      //     imgs: require("../assets/img/header/DCI2.png"),
      //     type: 1
      //   },
      //   {
      //     name: "云专线",
      //     names: "SD-Cloud 1",
      //     img1: require("../assets/img/header/cloud1.png"),
      //     img: require("../assets/img/header/cloud1.png"),
      //     imgs: require("../assets/img/header/cloud.png"),
      //     type: 2
      //   },
      //   {
      //     name: "定向加速",
      //     names: "DA",
      //     img1: require("../assets/img/header/speed.png"),
      //     img: require("../assets/img/header/speed.png"),
      //     imgs: require("../assets/img/header/speed2.png"),
      //     type: 3
      //   },
      //   {
      //     name: "SD-WAN",
      //     names: "SD-WAN",
      //     img1: require("../assets/img/header/SD-WAN.png"),
      //     img: require("../assets/img/header/SD-WAN.png"),
      //     imgs: require("../assets/img/header/SD-WAN2.png"),
      //     type: 4
      //   }
      // ],
      // solutList: [
      //   {
      //     name: "混合云方案",
      //     img1: require("../assets/img/header/headhunhe.png"),
      //     img: require("../assets/img/header/headhunhe.png"),
      //     imgs: require("../assets/img/header/headhunhe2.png"),
      //     type: 1
      //   },
      //   {
      //     name: "企业私有网",
      //     img1: require("../assets/img/header/headsiyou.png"),
      //     img: require("../assets/img/header/headsiyou.png"),
      //     imgs: require("../assets/img/header/headsiyou2.png"),
      //     type: 2
      //   }
      // ],
      // aboutus: [
      //   {
      //     name: "公司简介",
      //     img1: require("../assets/img/header/conpy1.png"),
      //     img: require("../assets/img/header/conpy1.png"),
      //     imgs: require("../assets/img/header/conpy2.png"),
      //     type: 1
      //   },
      //   {
      //     name: "服务承诺",
      //     img1: require("../assets/img/header/serve1.png"),
      //     img: require("../assets/img/header/serve1.png"),
      //     imgs: require("../assets/img/header/serve2.png"),
      //     type: 2
      //   }
      // ],
      navname: [
        {
          name: "main"
        },
        {
          name: "product"
        },
        {
          name: "solution"
        },
        {
          name: "price"
        },
        {
          name: "service"
        },
        {
          name: "aboutus"
        },
        {
          name: "product2"
        },
        {
          name: "product3"
        },
        {
          name: "product4"
        },
        {
          name: "solutegrop"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    handleMain() {
      this.$router.push({
        name: "main"
      });
    },
    handleProject(type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: "product"
          });
          break;
        case 2:
          this.$router.push({
            name: "product2"
          });
          break;
        case 3:
          this.$router.push({
            name: "product3"
          });
          break;
        case 4:
          this.$router.push({
            name: "product4"
          });
          break;
        default:
          this.$router.push({
            name: "product5"
          });
          break;
      }
    },
    handleSolute(type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: "solution"
          });
          break;
        default:
          this.$router.push({
            name: "solutegrop"
          });
          break;
      }
    },
    handlePanner() {
      this.$router.push({
        name: "partner"
      });
    },
    handleCase() {
      this.$router.push({
        name: "case"
      });
    },
    handleus(type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: "aboutus"
          });
          break;
        default:
          this.$router.push({
            name: "service"
          });
          break;
      }
    },
    handlePrice() {
      this.$router.push({
        name: "price"
      });
    }
  }
};
</script>
<style lang="scss">
.navhead {
  width: 100%;
  background-color: #011801;
  // opacity: 0.8;
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;
  // position: absolute;
  z-index: 13000;
  .headerTitle {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    .wiew {
      color: #ccc;
      font-size: 14px;
      margin-right: 50px;
      text-align: left;
    }
    .wiew:hover {
      cursor: pointer;
      color: #248f47;
      border-bottom: 2px solid #248f47;
    }
    .right {
      cursor: pointer;
      color: #248f47;
      border-bottom: 2px solid #248f47;
    }
    .rights {
      cursor: pointer;
      color: #248f47;
      border-bottom: 2px solid #248f47;
    }
    .el-dropdown-link {
      cursor: pointer !important;
      font-size: 16px !important;
      color: #ccc;
    }
  }
}
</style>
